import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { AuthenticatedUserInfoProvider } from './services/Contexts/AuthenticatedUserInfoContext';
import SessionIdleProvider from './services/Contexts/SessionIdleProvider';
import { Elements } from '@stripe/react-stripe-js';
import getStripePromise from './utils/stripePromise';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import chakraTheme from './theme';
import { BrandThemeProvider } from './services/Contexts/BrandThemeContext';
import { PageTitleProvider } from './services/Contexts/PageTitleContext';
import { FeatureGateProvider } from './services/Contexts/FeatureGateContext';
import { PlanFeatureAccessProvider } from './services/Contexts/PlanFeatureAccessContext';
import GoogleAnalyticsTracker from './components/GoogleAnalytics/GoogleAnalyticsTracker';

// Create a QueryClient instance
const queryClient = new QueryClient();

const stripePromise = getStripePromise();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<Router>
			<GoogleAnalyticsTracker />
			<QueryClientProvider client={queryClient}>
				<AuthenticatedUserInfoProvider>
					<Elements stripe={stripePromise}>
						<BrandThemeProvider theme={chakraTheme}>
							<SessionIdleProvider>
								<PageTitleProvider>
									<FeatureGateProvider>
										<PlanFeatureAccessProvider>
											<App />
										</PlanFeatureAccessProvider>
									</FeatureGateProvider>
								</PageTitleProvider>
							</SessionIdleProvider>
						</BrandThemeProvider>
					</Elements>
				</AuthenticatedUserInfoProvider>
			</QueryClientProvider>
		</Router>
	</React.StrictMode>,
);
